import { render } from "./ProductPage.vue?vue&type=template&id=40dbe5f2&scoped=true"
import script from "./ProductPage.vue?vue&type=script&lang=js"
export * from "./ProductPage.vue?vue&type=script&lang=js"

import "./ProductPage.vue?vue&type=style&index=0&id=40dbe5f2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40dbe5f2"]])

export default __exports__